import { Component, Inject } from '@angular/core';
import { ListAllDomainsResponseInterface, Sender, SenderType } from '@vendasta/email';
import { EMPTY, Observable } from 'rxjs';
import { MAT_DIALOG_DATA, MatDialogActions, MatDialogClose, MatDialogContent, MatDialogRef, MatDialogTitle } from '@angular/material/dialog';
import { map } from 'rxjs/operators';
import { Data as ButtonData, DomainStatusAndNameComponent } from './domain-status-and-name/domain-status-and-name.component';
import { DomainCacheService } from '../domain-cache.service';
import { TranslateModule } from '@ngx-translate/core';
import { GalaxyPipesModule } from '@vendasta/galaxy/pipes';
import { AsyncPipe } from '@angular/common';
import { MatListOption, MatSelectionList } from '@angular/material/list';
import { GalaxyLoadingSpinnerModule } from '@vendasta/galaxy/loading-spinner';
import { GalaxyEmptyStateModule } from '@vendasta/galaxy/empty-state';
import { MatIcon } from '@angular/material/icon';
import { MatButton } from '@angular/material/button';

export type ChoiceType = 'new' | 'valid' | 'invalid';

export interface Result {
  newDomain: string | undefined;
  choiceType: ChoiceType;
}

@Component({
  selector: 'email-domains-dialog',
  templateUrl: './domains-dialog.component.html',
  styleUrls: ['./domains-dialog.component.scss'],
  imports: [
    MatDialogTitle,
    TranslateModule,
    MatDialogContent,
    GalaxyPipesModule,
    AsyncPipe,
    MatSelectionList,
    MatListOption,
    DomainStatusAndNameComponent,
    GalaxyLoadingSpinnerModule,
    GalaxyEmptyStateModule,
    MatIcon,
    MatDialogActions,
    MatButton,
    MatDialogClose,
  ],
})
export class DomainsDialogComponent {
  allDomains$: Observable<ButtonData[]> = EMPTY;

  constructor(
    private readonly domainService: DomainCacheService, //
    @Inject(MAT_DIALOG_DATA) sender: Sender,
    readonly self: MatDialogRef<DomainsDialogComponent>,
  ) {
    this.refreshDomains(sender);
  }

  private refreshDomains(sender: Sender): void {
    if (!sender.id || sender.type === SenderType.SENDER_TYPE_INVALID) {
      return;
    }
    // We replace the entire observable because errors cause the original observable to complete
    this.allDomains$ = this.domainService
      .listAllDomains(sender.type, sender.id)
      .pipe(map((v) => convertListResponseToButtonData(sender, v)));
  }

  handleDomainChangeRequested(domain: string, isValidDomain: boolean): void {
    this.self.close({
      newDomain: domain,
      choiceType: isValidDomain ? 'valid' : 'invalid',
    } as Result);
  }

  handleNewDomainRequested(): void {
    this.self.close({
      newDomain: '',
      choiceType: 'new',
    } as Result);
  }
}

function convertListResponseToButtonData(sender: Sender, response: ListAllDomainsResponseInterface): ButtonData[] {
  return response.domains.map(
    (v) =>
      ({
        domain: v,
        sender: sender,
      }) as ButtonData,
  );
}
